import '../scss/blog.scss';

import "../components/main-blog";

document.addEventListener('DOMContentLoaded', () => {
  function handleize(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  const summaryToggle = document.querySelector('#summary_toggle');
  const breadcrumbsElement = document.querySelector('.breadcrumb');
  const mainArticleElement = document.querySelector('.main-article');
  const summaryElement = document.querySelector('#summary');


  if (!summaryToggle) return;

  summaryToggle.addEventListener('click', () => {
    let isActive = summaryToggle.parentNode.dataset.active;

    if (isActive == 'true') {
      summaryToggle.parentNode.setAttribute('data-active', false);
    } else {
      summaryToggle.parentNode.setAttribute('data-active', true);
    }
  });

  function moveSummaryElement() {
    if (window.innerWidth < 992) {
      breadcrumbsElement.insertAdjacentElement('beforebegin', summaryElement);
    } else {
      mainArticleElement.prepend(summaryElement);
    }
  }

  moveSummaryElement();

  const summaryList = document.querySelector('#article_summary');
  const article = document.querySelector('#article_content');
  const headers = article.querySelectorAll('h2:not(.not-summary__heading)');
  const bullet = window.article_bullet;
  let listItems = [];

  headers.forEach((header, index) => {
    if (!header.querySelector('img')) {
      if (header.tagName === 'H2') {
        const handleizedText = handleize(header.textContent);
        header.setAttribute('data-href', handleizedText);
      }

      index += 1;

      const listItem = document.createElement('li');
      listItem.setAttribute('data-href', handleize(header.textContent));
      const headerItem = '<i>' +index+'.</i><span>' + header.textContent.trim() + '</span>' + bullet;

      listItem.innerHTML = headerItem;
      summaryList.appendChild(listItem);

      listItems.push(listItem);
    }
  });

  listItems[0].classList.add('active')

  window.addEventListener('resize', moveSummaryElement);

  document.addEventListener(
    'click',
    (event) => {
      let targetElement = event.target;

      while (targetElement != null) {
        if (targetElement.matches('#summary li[data-href]')) {
          event.preventDefault();

          const href = targetElement.dataset.href;
          const title = article.querySelector('#article_content [data-href="' + href + '"]');
          let offset = 100;

          window.scrollTo({
            top: title.getBoundingClientRect().top + document.documentElement.scrollTop - offset,
            behavior: 'smooth',
          });

          return;
        }
        targetElement = targetElement.parentElement;
      }
    },
    false
  );


  let activeHeader = null;

  const firstElement = headers[0];
  firstElement.classList.add('active');
  activeHeader = firstElement;

  const observerOptions = {
    root: null,
    rootMargin: '20% 0px -50% 0px',
    threshold: [0, 1],
  };

  const observerCallback = (entries, observer) => {
    let wasAbove = false;

    entries.forEach((entry) => {
      const href = entry.target.getAttribute('data-href');
      const anchorElement = document.querySelector(`#article_summary [data-href="${href}"]`);
      const isAbove = entry.boundingClientRect.y < entry.rootBounds.y;

      if (entry.isIntersecting) {
        if (activeHeader && activeHeader !== anchorElement) {
          activeHeader.classList.remove('active');
        }

        anchorElement.classList.add('active');
        activeHeader = anchorElement;
      }

      wasAbove = isAbove;
    });

    if (wasAbove && entries.length > 0) {
      const lastEntry = entries[entries.length - 1];
      const lastElement = document.querySelector(`#article_summary [data-href="${lastEntry.target.getAttribute('data-href')}"]`);
      if (activeHeader && activeHeader !== lastElement) {
        activeHeader.classList.remove('active');
      }
      lastElement.classList.add('active');
      activeHeader = lastElement;
    }
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  headers.forEach((header) => {
    observer.observe(header);
  });

});
